import { render } from "./receipt-examples.vue?vue&type=template&id=e70f6d7c&scoped=true"
import script from "./receipt-examples.vue?vue&type=script&lang=js"
export * from "./receipt-examples.vue?vue&type=script&lang=js"

import "./receipt-examples.vue?vue&type=style&index=0&id=e70f6d7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70f6d7c"]])

export default __exports__